import { render, staticRenderFns } from "./LayoutTestingDailyGame.vue?vue&type=template&id=28b0d6c5&"
import script from "./LayoutTestingDailyGame.vue?vue&type=script&lang=js&"
export * from "./LayoutTestingDailyGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports